import React from 'react';

import type { PluginProps } from './../../ricos-types';
import type { PmAudioNode } from './../../_shared/pm-node-types';

import { fromPmAudioAnyState } from '../converters/from-pm-audio-any-state';
import AudioViewer from '../viewer/audio-viewer';

export const Audio: React.FC<PluginProps> = ({ settings, node, updateAttributes }) => {
  const { loading } = node.attrs;

  const ricosNode = fromPmAudioAnyState(node as unknown as PmAudioNode);

  return (
    <AudioViewer
      node={ricosNode}
      updateAttributes={updateAttributes}
      settings={settings}
      isLoading={loading}
    />
  );
};
